
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    TOURNAMENTSCORE_ACTION,
    ALL_TOURNAMENTSCORE,
    ADD_TOURNAMENTSCORE,
    FETCH_TOURNAMENTSCORE,
    EDIT_TOURNAMENTSCORE,
    DELETE_TOURNAMENTSCORE,
    FETCH_TOURNAMENTSCORECHART
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Tournament Score Actions
 */

    export const allTournamentScore = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: TOURNAMENTSCORE_ACTION });
            return axios.get(AppConfig.apiurl+'/api/gettournamentscrmaster', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_TOURNAMENTSCORE, payload: alldata });
            });
        }        
    
    }

    export const studentTournamentScore = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:TOURNAMENTSCORE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studenttournamentscrmaster', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data.data;
                dispatch({ type: ALL_TOURNAMENTSCORE, payload: alldata }); 
            });
        
        }
    }

    export const addTournamentScore = (data) =>{
        var id=data.target.student.value;
        var payload={
            "tournament":data.target.tournament.value,
            "course":data.target.course.value,
            "country":data.target.country.value,
            "student_1":data.target.student.value,
            "rounds_1":data.target.round.value,
            "position_1":data.target.position.value,
            "rd1_1":data.target.roundscore_1.value,
            "rddate1_1":data.target.rounddate_1.value,
            "totval":1,
        }
        var round=data.target.round.value;
        if(round==2){
            payload['rd2_1']=data.target.roundscore_2.value;
            payload['rd3_1']="";
            payload['rd4_1']="";
            payload['rddate2_1']=data.target.rounddate_2.value;
            payload['rddate3_1']="";
            payload['rddate4_1']="";
        }else if(round==3){
            payload['rd2_1']=data.target.roundscore_2.value;
            payload['rd3_1']=data.target.roundscore_3.value;
            payload['rd4_1']="";
            payload['rddate2_1']=data.target.rounddate_2.value;
            payload['rddate3_1']=data.target.rounddate_3.value;
            payload['rddate4_1']="";
        }else if(round==4){
            payload['rd2_1']=data.target.roundscore_2.value;
            payload['rd3_1']=data.target.roundscore_3.value;
            payload['rd4_1']=data.target.roundscore_4.value;
            payload['rddate2_1']=data.target.rounddate_2.value;
            payload['rddate3_1']=data.target.rounddate_3.value;
            payload['rddate4_1']=data.target.rounddate_4.value;
        }
        return (dispatch) => { 
            dispatch({ type:TOURNAMENTSCORE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addtournamentscrmaster', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start="";
                    var end="";
                    studentTournamentScore(id, start, end)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_TOURNAMENTSCORE});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchTournamentScore = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:TOURNAMENTSCORE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchtournamentscrmaster', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_TOURNAMENTSCORE, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editTournamentScore = (data) =>{
        var id=data.target.student.value;
        var payload={
            "tournament":data.target.tournament.value,
            "course":data.target.course.value,
            "country":data.target.country.value,
            "student":data.target.student.value,
            "rounds":data.target.round.value,
            "position":data.target.position.value,
            "rd1":data.target.roundscore_1.value,
            "rddate1":data.target.rounddate_1.value,
            "gtrID":data.target.oldid.value,
        }
        var round=data.target.round.value;
        if(round==2){
            payload['rd2']=data.target.roundscore_2.value;
            payload['rd3']="";
            payload['rd4']="";
            payload['rddate2']=data.target.rounddate_2.value;
            payload['rddate3']="";
            payload['rddate4']="";
        }else if(round==3){
            payload['rd2']=data.target.roundscore_2.value;
            payload['rd3']=data.target.roundscore_3.value;
            payload['rd4']="";
            payload['rddate2']=data.target.rounddate_2.value;
            payload['rddate3']=data.target.rounddate_3.value;
            payload['rddate4']="";
        }else if(round==4){
            payload['rd2']=data.target.roundscore_2.value;
            payload['rd3']=data.target.roundscore_3.value;
            payload['rd4']=data.target.roundscore_4.value;
            payload['rddate2']=data.target.rounddate_2.value;
            payload['rddate3']=data.target.rounddate_3.value;
            payload['rddate4']=data.target.rounddate_4.value;
        }
       
        return (dispatch) => { 
            dispatch({ type:TOURNAMENTSCORE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/edittournamentscrmaster', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start="";
                    var end="";
                    studentTournamentScore(id, start, end)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_TOURNAMENTSCORE});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteTournamentScore = (id, usrid) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:TOURNAMENTSCORE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deletetournamentscrmaster', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start="";
                    var end="";
                    studentTournamentScore(usrid, start, end)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_TOURNAMENTSCORE});                    
                }
                
                
            });
        
        }
    }

    export const fetchTournamentChart = (id, allid, tournament) =>{
    
        var payload={
            "id":id,
            "allid":allid,
            "tournament":tournament          
        }

        return (dispatch) => { 
            dispatch({ type:TOURNAMENTSCORE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/reporttournamentscrmaster', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_TOURNAMENTSCORECHART, payload: resdata}); 
                
                return Promise.resolve(resdata);
                
            });
        
        }
    }


   

